import React from 'react'
import { Route, Switch } from 'react-router'
import ReportTrailerCosts from './ReportTrailerCosts'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportTrailerCosts} />
    </Switch>
)

export default Components
